import { getEnv } from "../env";

export function setApiDomain(configuration) {
	const apiDomain = getEnv('REACT_APP_API_DOMAIN');

	apiDomain && configuration &&  configuration.api && 
	Object.keys(configuration.api).forEach(function(k) {
		
		if (window.appConfig && window.appConfig.IS_LOCALHOST) {
			const values = configuration.api[k].split("/");
			if (values.length >= 2) {
				values[1] = 'XSportDatastore'; // replacing XSportDatastoreMagnum
				configuration.api[k] = values.join('/');
			}
		}
		const v = configuration.api[k];
		const isSocketUrl = v.startsWith('ws:') || v.startsWith("wss:");
		if (!isSocketUrl && (!v.match(/(https?:\/\/.*):(\d*)\/?(.*)/g))) {
			configuration.api[k] = apiDomain+v;
		}
	})
	
}
